import angular from 'angular';
import _ from 'lodash';

class PrincipalPersonalisePortalCtrl {
    /*@ngInject*/
    constructor(PrincipalSvc, logger, EMAIL_REGEXP, BrandSvc, $http, CONF, $filter, BrandNavigation, AuthSvc) {
        this.PrincipalSvc = PrincipalSvc;
        this.logger = logger;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
        this.BrandSvc = BrandSvc;
        this.$http = $http;
        this.CONF = CONF;
        this.$filter = $filter;
        this.BrandNavigation = BrandNavigation;
        this.AuthSvc = AuthSvc;
    }

    $onInit() {
        this.filePrefix = this.CONF.apiContext + this.CONF.apiBaseUrl + '/v1/files/';
        this.isAuthorisedToUpdate = this.AuthSvc.isAuthorized('CONFIGURATOR');
        this.initParams(this.brand);
        this.DOMAIN_REGEXP = /^[a-zA-Z0-9-_]*\.[a-zA-Z0-9-_]*\.[a-zA-Z]{2,}$/;
        this.URL_REGEXP = /^(http|https):\/\/[a-zA-Z0-9-_]*\.[a-zA-Z0-9-_]*\.[a-zA-Z]{2,}/;
    }

    initParams(inBrand) {
        this.resetBrand = angular.copy(inBrand);
        this.resetResources = angular.copy(inBrand.newBrandResources);
        this.initImagesIds(this.brand.newBrandResources);
        this.resetLoginLogoId = this.checkLoginLogoId;
        this.resetPortalFaviconId = this.checkPortalFaviconId;
        this.resetLoginpictureId = this.checkLoginpictureId;
        this.resetPortailLogoId = this.checkPortailLogoId;
        this.resetPortalBgImages = angular.copy(this.checkPortalBgImages);
    }

    initImagesIds(Items) {
        let ctrl = this;
        ctrl.checkPortalBgImages = [];
        angular.forEach(Items, function (item) {
            if (item.fileHeaderId) {
                ctrl.getImagesIds(item.type, item.fileHeaderId);
            }
        });
    }

    loginLogoChange(logoId) {
        if (logoId.logoId !== undefined) {
            this.fileChange('LOGIN_LOGO', logoId.logoId, true);
        } else {
            this.fileChange('LOGIN_LOGO', null, true);
        }
    }

    portalFaviconChange(faviconId) {
        if (faviconId.faviconId !== undefined) {
            this.fileChange('PORTAL_FAVICON', faviconId.faviconId, false);
        } else {
            this.fileChange('PORTAL_FAVICON', null, false);
        }
    }

    loginLogoRemove(logoId) {
        this.checkLoginLogoId = null;
        this.deleteNewBrandResources(logoId.logoId);
    }

    portalFaviconRemove(faviconId) {
        this.checkPortalFaviconId = null;
        this.deleteNewBrandResources(faviconId.faviconId);
    }

    loginBgChange(logoBgId) {
        if (logoBgId.logoBgId !== undefined) {
            this.fileChange('LOGIN_BG', logoBgId.logoBgId, false);
        } else {
            this.fileChange('LOGIN_BG', null, false);
        }
    }

    loginBgRemove(logoBgId) {
        this.checkLoginpictureId = null;
        this.deleteNewBrandResources(logoBgId.logoBgId);
    }

    portalLogoChange(portalLogoId) {
        if (portalLogoId.portalLogoId !== undefined) {
            this.fileChange('PORTAL_LOGO', portalLogoId.portalLogoId, true);
        } else {
            this.fileChange('PORTAL_LOGO', null, true);
        }
    }

    portalLogoRemove(portalLogoId) {
        this.checkPortailLogoId = null;
        this.deleteNewBrandResources(portalLogoId.portalLogoId);
    }

    portalBgChange(portalBgId) {
        if (portalBgId.portalBgId !== undefined) {
            this.fileChange('PORTAL_BG', portalBgId.portalBgId, false);
        }
    }

    portalBgAdd() {
        this.fileChange('PORTAL_BG', null, false);
    }

    portalBgRemove(portalBgId) {
        if (portalBgId.portalBgId !== undefined) {
            this.deletePortalImageId(portalBgId.portalBgId);
            this.deleteNewBrandResources(portalBgId.portalBgId);
        }
    }

    fileChange(type, oldFileId, isLogo) {
        var isFavicon = type === 'PORTAL_FAVICON' ? true : false;
        let ctrl = this;
        if (ctrl.file != null && ctrl.verifyFile(ctrl.file, isLogo, isFavicon)) {
            ctrl.BrandSvc.saveFile(ctrl.file).then(function (data) {
                ctrl.getImagesIds(type, data.id);
                if (oldFileId != null) {
                    ctrl.deleteNewBrandResources(oldFileId);
                    ctrl.addNewBrandResource(type, data.id);
                    if (type === 'PORTAL_BG') {
                        ctrl.deletePortalImageId(oldFileId);
                    }
                } else {
                    ctrl.addNewBrandResource(type, data.id);
                }
            }, function (error) {
                if (error.status === 406) {
                    if (isLogo) {
                        ctrl.logger.warn(
                            'Le Logo importé ne respecte pas les critères ( Type de fichier : (.PNG), Le poids du logo (maximum 200 Ko))'
                        );
                    } else if (isFavicon) {
                        ctrl.logger.warn(
                            'La Favicon  importée ne respecte pas les critères ( Type de fichier : (.PNG), Le poids de la favicon (maximum 3 Ko))'
                        );
                    } else {
                        ctrl.logger.warn(
                            "Le format de l'image importée ne respecte pas les critères du format attendu (Type de fichier : JPG, PNG, Le poids des images : 350 Ko)"
                        );
                    }
                }
            });
        }
    }

    deleteNewBrandResources(fileHeaderId) {
        this.brand.newBrandResources = this.$filter('filter')(this.brand.newBrandResources, function (nbr) {
            return nbr.fileHeaderId !== fileHeaderId;
        });
    }

    addNewBrandResource(fileType, fileId) {
        this.brand.newBrandResources.push({fileHeaderId: fileId, type: fileType});
    }

    deletePortalImageId(oldFilId) {
        this.checkPortalBgImages = this.$filter('filter')(this.checkPortalBgImages, function (imageId) {
            return imageId !== oldFilId;
        });
    }

    getImagesIds(type, fileId) {
        if (fileId) {
            if (type === 'LOGIN_LOGO') {
                this.checkLoginLogoId = fileId;
            }
            if (type === 'PORTAL_FAVICON') {
                this.checkPortalFaviconId = fileId;
            }
            if (type === 'LOGIN_BG') {
                this.checkLoginpictureId = fileId;
            }
            if (type === 'PORTAL_LOGO') {
                this.checkPortailLogoId = fileId;
            }
            if (type === 'PORTAL_BG') {
                this.checkPortalBgImages.push(fileId);
            }
        }
    }
    checkIfCustomerUrlHasError() {
        return (
            !this.form.customerUrl.$valid &&
            (this.form.customerName.$dirty || this.form.customerUrl.$dirty || this.form.$submitted)
        );
    }

    verifyFile(file, isLogo, isFavicon) {
        var isValid = true;
        let formatLogoAccepted = ['image/png'];
        let formatImageAccepted = ['image/jpeg', 'image/jpg', 'image/png'];
        if (isLogo) {
            if (!_.includes(formatLogoAccepted, file.type) || file.size / 1024 > 200) {
                this.logger.warn(
                    'Le Logo importé ne respecte pas les critères ( Type de fichier : (.PNG), Le poids du logo (maximum 200 Ko))'
                );
                isValid = false;
            }
        } else if (isFavicon) {
            if (!_.includes(formatLogoAccepted, file.type) || file.size / 1024 > 3) {
                this.logger.warn(
                    'La Favicon  importée ne respecte pas les critères ( Type de fichier : (.PNG), Le poids de la favicon (maximum 3 Ko))'
                );
                isValid = false;
            }
        } else if (!_.includes(formatImageAccepted, file.type) || file.size / 1024 > 350) {
            this.logger.warn(
                "Le format de l'image importée ne respecte pas les critères du format attendu (Type de fichier : JPG, PNG, Le poids des images : 350 Ko)"
            );
            isValid = false;
        }
        return isValid;
    }

    resetBlocs() {
        this.brand.loginUrl = this.resetBrand.loginUrl;
        this.checkLoginLogoId = this.resetLoginLogoId;
        this.checkPortalFaviconId = this.resetPortalFaviconId;
        this.checkLoginpictureId = this.resetLoginpictureId;
        this.brand.brandNavigation = new this.BrandNavigation(this.resetBrand.brandNavigation);
        this.checkPortailLogoId = this.resetPortailLogoId;
        this.brand.mail = this.resetBrand.mail;
        this.brand.portalName = this.resetBrand.portalName;
        this.brand.customerName = this.resetBrand.customerName;
        this.brand.customerUrl = this.resetBrand.customerUrl;
        this.brand.contactUrl = this.resetBrand.contactUrl;
        this.brand.registrationReq = this.resetBrand.registrationReq;
        this.brand.registrationReqCode = this.resetBrand.registrationReqCode;
        this.resetNewBrandResource();
        this.resetBgImagesId();
    }

    resetNewBrandResource() {
        this.brand.newBrandResources.length = 0;
        this.brand.newBrandResources = this.$filter('filter')(this.resetResources, function (rcs) {
            return rcs;
        });
    }

    resetBgImagesId() {
        this.checkPortalBgImages.length = 0;
        this.checkPortalBgImages = this.$filter('filter')(this.resetPortalBgImages, function (bgI) {
            return bgI;
        });
    }

    cancel() {
        this.brand.portalPersonalise = this.resetBrand.portalPersonalise;
        this.resetBlocs();
    }

    save() {
        let ctrl = this;
        if (ctrl.form.$valid) {
            ctrl.BrandSvc.saveBrand(ctrl.brand).then(
                data => {
                    ctrl.brand = data;
                    ctrl.initParams(ctrl.brand);
                    if (this.brand.principalId != null) {
                        ctrl.logger.success('success.do_update', data);
                    } else {
                        this.logger.success('success.community_update', data);
                    }
                },
                function (error) {
                    ctrl.logger.error('error.update', error);
                }
            );
        }
    }
}

angular.module('app.principal').component('principalPersonalisePortal', {
    templateUrl: require('./brand-personalise-portal.html'),
    controller: PrincipalPersonalisePortalCtrl,
    bindings: {
        brand: '<',
        mode: '<'
    },
});
